import { X } from 'react-feather';
import { iconStyles } from 'styles/theme';
import styled from '@emotion/styled';

export const XIcon = styled(X)({
  color: iconStyles.colors.primary,
  '&:hover': {
    cursor: 'pointer',
  },
});
